import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { environment } from '../../environments/environment';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { Location } from '@angular/common';

@Component({
  selector: 'app-daily-hospital-cash',
  templateUrl: './daily-hospital-cash.component.html',
  styleUrls: ['./daily-hospital-cash.component.css']
})
export class DailyHospitalCashComponent implements OnInit {
  name: string;
  email: string;
  mobile: string;
  useId:any;
  inputVal:any;
  inputValChild:any;
  loading:Boolean;
  data:{};
  prospectIdDca: string;
  partnerId: string;
  error:string;
  private onDestroy$: Subject<void> = new Subject<void>();
  

   //for disabling div  in production
  constructor(private router: Router, private _location: Location, private serviceURLService: serviceURLService) {
    this.name = localStorage.getItem('name');
    this.email = localStorage.getItem('email');
    this.mobile = localStorage.getItem('mobileNumber');
    this.useId=localStorage.getItem('userID');
  }

  ngOnInit() {
  }
  handleDailyInput(event: any){
    this.inputVal=event.target.value
    console.log(this.inputVal)
    this.error=''
  }
  handleDailyInputChild(event: any){
    this.inputValChild=event.target.value
    console.log(this.inputValChild)
  }
  handleKeyDown(event:any){
    if (event.key === 'e' || event.key === '.'||event.key === 'E') {
      event.preventDefault();
    }
  }
  createProspectForDCA() {
    if(!this.inputVal&&!this.inputValChild){
      this.error="Please select any option"
    }
    else if(this.inputVal==="yes"&&!this.inputValChild){
      this.error="Please enter childrens"
    }
    else if(this.inputVal==="yes"&&(this.inputValChild>3 || this.inputValChild<0)){
      this.error="Children count can not be less than 0 or greater than 3"
    }
    else{
      console.log("&spouse="+this.inputVal+"&children="+this.inputValChild)
      this.error=''
      this.loading = true;
      this.prospectIdDca = localStorage.getItem('prospectIdDca');
      this.data = {
        mobile: this.mobile,
        prospectId: this.prospectIdDca?this.prospectIdDca:"",
        quoteId: "",
        rmId: "",
        product: 150,
        email: this.email,
        name: this.name,
        company: "",
        location: "",
        designation: "",
        comment: "",
        partnerId: this.partnerId,
        channel: "",
        leadSource: "Notify-App",
        googleClickID: "",
        couponCode: ""
      }
      console.log(this.data,this.inputValChild)
      
        this.serviceURLService.createProspectForDCA(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
          this.loading = false;
          localStorage.setItem("prospectIdDca", successData.data.prospectId);
          if(this.inputVal==="yes"){
            this.inputVal=true
          }
          else{
            this.inputVal=false
          }
          if(!this.inputValChild){
            this.inputValChild=false
          }
          else{
            this.inputValChild=this.inputValChild
          }
          window.open(environment.pam2Url + '/individual-insurance/daily-hospital-cash/quote?redirectionFromApp=true&&prospect='
          + successData.data.prospectId+"&spouse="+this.inputVal+"&children="+this.inputValChild);
          this.router.navigate(['/home'])
          return
        },
         errorData => {
          console.log("Oops..!! there is some error in prospect creation");
          if (errorData.error.status === 403) {
            this.error = errorData.error.message;
          }
        });
      
    }
    }
}
